(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["MlbTbdTeamToLeagueMap"] = factory();
	else
		root["MlbTbdTeamToLeagueMap"] = factory();
})(this, function() {

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/******/return (function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 0);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    var DEFAULT_ID_STR = '000';
    var AL_ID_STR = '159';
    var NL_ID_STR = '160';

    var data = {
        mappings: {
            // AL:
            4614: AL_ID_STR, // Div. Winner #1
            4615: AL_ID_STR, // Div. Winner #2
            4616: AL_ID_STR, // Div. Winner #3
            4944: AL_ID_STR, // Higher Seed
            4945: AL_ID_STR, // Lower Seed
            4612: AL_ID_STR, // Wild Card
            3370: AL_ID_STR, // TBD - DS 'A'
            3371: AL_ID_STR, // TBD - DS 'B'
            21: AL_ID_STR, // League Champion

            // NL:
            4617: NL_ID_STR, // Div. Winner #1
            4618: NL_ID_STR, // Div. Winner #2
            4619: NL_ID_STR, // Div. Winner #3
            4946: NL_ID_STR, // Higher Seed
            4947: NL_ID_STR, // Lower Seed
            4613: NL_ID_STR, // Wild Card
            3372: NL_ID_STR, // TBD - DS 'A'
            3373: NL_ID_STR, // TBD - DS 'B'
            31: NL_ID_STR, // League Champion

            // Generic: The two teams playing in the WS, _before_ we know which league's pennant winner will be the home
            // team (once known, team IDs 21 and 31 - see above - are used).  Not strictly necessary to map these to
            // DEFAULT_ID_STR because this is the default anyway; just being explicit:
            2710: DEFAULT_ID_STR, // League Champion #1
            2711: DEFAULT_ID_STR // League Champion #2
        },
        defaultIdStr: DEFAULT_ID_STR,
        alIdStr: AL_ID_STR,
        nlIdStr: NL_ID_STR
    };

    var MlbTbdTeamToLeagueMap = function () {

        /**
         * @throws `Error` if called; this class cannot be instantiated.
         */
        function MlbTbdTeamToLeagueMap() {
            _classCallCheck(this, MlbTbdTeamToLeagueMap);

            throw new Error('MlbTbdTeamToLeagueMap cannot be instantiated.');
        }

        /**
         * Passed the ID of a "TBD team" (pseudo-teams which exist in MLB data for postseason games until it is known
         * which actual teams will play in those games), returns one of these strings: "103" (AL); "104" (NL); or "000"
         * (the default, if the ID isn't recognized, or if it's ID 2710 or 2711 (the two world-series clubs before we know
         * which league will be home/away), or if it's simply invalid input.  These three possible return values are
         * expected to be used to build logo URLs; the reason for the padded "000" is that "000.svg" is the generic icon
         * depicting a baseball.
         *
         * Note that "000.svg" is found (as of 9/11/2017) in "/images/logos/team-cap-on-[dark/light]/", while "103.svg"
         * and "104.svg" are found elsewhere (currently as of 9/11/2017) only in "/images/logos/league-on-light/".
         *
         * Also see `getLeagueInfoFromTbdTeamId()` in this class, a lower-level method which may be cleaner to work with,
         * depending on usage.
         *
         * Helpful info is here: https://jira.mlbam.com/browse/SSSS-4943
         *
         * @param {number|string} teamId The ID of a "TBD team" such as 4617 ("NL Div. Winner #1").  May be a number, or a
         *      string representation of a number.
         * @return {string} One of "103", "104", or "000"
         * @see MlbTbdTeamToLeagueMap.getLeagueInfoFromTbdTeamId
         */


        _createClass(MlbTbdTeamToLeagueMap, null, [{
            key: 'getLeagueIdFromTbdTeamId',
            value: function getLeagueIdFromTbdTeamId(teamId) {
                var leagueInfo = MlbTbdTeamToLeagueMap.getLeagueInfoFromTbdTeamId(teamId);
                return leagueInfo.unknownLeague ? data.defaultIdStr : leagueInfo.leagueId;
            }

            /**
             * A lower-level but generally cleaner alternative to the `getLeagueIdFromTbdTeamId()` method in this class.
             * Passed a `teamId`
             * expected to be the ID of a "TBD team" (pseudo-team which exists in MLB data for postseason games until it is
             * known which actual active teams will play in those games), returns ab object with two
             * properties: `unknownLeague`, a boolean indicating whether this TBD team is associated with a league or not; and
             * `leagueId`, the ID (as a string) of the league if `unknownLeague` is true - otherwise this property should be
             * ignored.
             *
             * Helpful info is here: https://jira.mlbam.com/browse/SSSS-4943
             *
             * @param {number|string} teamId The ID of a "TBD team" such as 4617 ("NL Div. Winner #1").  May be a number, or a
             *      string representation of a number.
             * @return {{unknownLeague: boolean, leagueId: string}}
             * @see https://jira.mlbam.com/browse/SSSS-4943
             */

        }, {
            key: 'getLeagueInfoFromTbdTeamId',
            value: function getLeagueInfoFromTbdTeamId(teamId) {
                var teamIdNum = parseInt('' + teamId);

                if (isNaN(teamIdNum)) {
                    teamIdNum = 0;
                }
                var isRecognizedLeagueId = !!data.mappings[teamIdNum];
                var leagueIdStr = data.mappings[teamIdNum] || data.defaultIdStr;
                var isLeagueId = leagueIdStr !== data.defaultIdStr;
                return {
                    unknownLeague: !isLeagueId,
                    isRecognizedLeagueId: isRecognizedLeagueId,
                    leagueId: isLeagueId ? leagueIdStr : null
                };
            }

            /**
             * Returns true if this is a postseason "tbd team", false if it's anything else (an active team; a formerly active
             * team; one of the ASG teams; an xref team; bad input; etc.).
             * @param {number|string} teamId Numeric team ID, as a number or string.
             * @return {boolean}
             */

        }, {
            key: 'isTbdTeam',
            value: function isTbdTeam(teamId) {
                var leagueInfo = MlbTbdTeamToLeagueMap.getLeagueInfoFromTbdTeamId(teamId);
                return !leagueInfo.unknownLeague || leagueInfo.isRecognizedLeagueId;
            }
        }]);

        return MlbTbdTeamToLeagueMap;
    }();

    module.exports = MlbTbdTeamToLeagueMap;

    /***/
}]
/******/);
});